module.exports = __webpack_public_path__ + "static/media/googlePlay-icon.306cca6a.svg";